import { useCustomersServiceObjectShowQuery } from "@/services/backend/customers/api/service-object-api";

export function ServiceObjectName({ id }: { id?: string }) {
  const { data } = useCustomersServiceObjectShowQuery({ id: id ?? "" });

  if (!data) {
    return "";
  }

  return <span>{data.name}</span>;
}
